/**
 * @desc 根据id查询Details
 */

import fetch from '@/utils/request'
import config from '@/config'

export interface QueryParams {}

export function request(data: defs.AuthServiceIDParameter): Promise<BaseResponse<defs.ResultBean<defs.SysConfigEntity>>> {
  return fetch({
    url: config.API_HOST + '/sys/sysConfig/findById',
    data: data,
    method: 'POST',
    credentials: 'include',
    timeout: 20 * 1000,
  })
}
